/**
 * File: activityPreview.js
 * Project: educore
 * Created Date: 2018-12-13
 * Author: Raziya S
 * Screen : 
 */
import metadataPopUpTemplate from '../../../../traditionalActivity/views/question-meta-data.html'

class QpPreviewController {
    // @ngInject
    constructor($state, $rootScope, $scope, $mdMedia, $filter, $mdDialog, $timeout, localStorageService, authService, activityCons, $stateParams, SchoolLogo, CONSTANTS, $sce) {
        this.writeNote = false;
        this.scope = $scope;
        this.state = $state;
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let academics = localStorageService.get('authoringData')
        if (academics === undefined)
            $state.go('dashboard')
        let userId = localStorageService.get('user_id')

        //String - Activity id
        //$scope.qpId = $state.params.qpId
        let qpId = $state.params.qpId

        //Boolean - Whether to show or hide close button
        $scope.isShowClose = localStorageService.get("isViewAllQuestion");

        //localStorageService.clear("isViewAllQuestion")

        //Boolean - To make activity password field visible
        $scope.isPassword = false;

        $scope.isCreator = false
        $scope.isConducted = false
        $scope.isLoading = true

        let schoolId = academics.school_id
        $scope.class = academics.class
        $scope.curriculum = academics.curriculum

        $scope.convertedURLAnswer = {}
        $scope.convertedURLQuestion = {}
        $scope.file_server_url = CONSTANTS.FILE_UPLOAD_URL

        $scope.chartUrl = 'https://chart.googleapis.com/chart?cht=tx&chf=bg,s,FFFFFF00&chl='
        let PREVIEW_URL = CONSTANTS.FILE_UPLOAD_URL
        $scope.fileUrl = PREVIEW_URL
        $scope.isViewMode = $scope.$parent.isViewMode
        let fieldAlignment = (eachQues) => {
            if (eachQues.questionImg && eachQues.questionImg.length) {
                convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQues.questionImg, function(base64Image) {
                    $scope.imgurl2 = base64Image;
                    eachQues.qn_img_url = $scope.imgurl2
                })
            }
            if (eachQues.qn_img_array && eachQues.qn_img_array.length) {
                eachQues.qn_img_urlarray = []
                _.each(eachQues.qn_img_array, function(eachQnImage) {
                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQnImage, function(base64Image) {
                        eachQues.qn_img_urlarray.push(base64Image)
                    })
                });
            }
            if (eachQues.choice && eachQues.choice.length > 0) {
                _.each(eachQues.choice, function(eachChoice) {
                    eachChoice.opt_image_url = []
                    _.each(eachChoice.optImage, function(eachOptImage) {
                        convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachOptImage, function(base64Image) {
                            eachChoice.opt_image_url.push(base64Image)
                        })
                    })
                    _.each(eachChoice.opt_img, function(eachOptImage) {
                        convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachOptImage, function(base64Image) {
                            eachChoice.opt_image_url.push(base64Image)
                        })
                    })
                })
            }
            if (eachQues.isLatex) {
                if (eachQues.optionQuestion && eachQues.optionQuestion.length && eachQues.optionAnswer && eachQues.optionAnswer.length) {
                    _.each(eachQues.optionQuestion, function(ques) {
                        let latexValue = encodeURIComponent(ques.desc)
                        let urlsec = $scope.chartUrl + latexValue
                        getDataUri(urlsec, function(base64Image) {
                            ques.latexDesc = base64Image
                        })
                    })
                    _.each(eachQues.optionAnswer, function(ans) {
                        let latexValue = encodeURIComponent(ans.desc)
                        let urlsec = $scope.chartUrl + latexValue
                        getDataUri(urlsec, function(base64Image) {
                            ans.latexDesc = base64Image
                        })
                    })
                } else {
                    let latexValue = encodeURIComponent(eachQues.qn_desc)
                    let urlsec = $scope.chartUrl + latexValue
                    getDataUri(urlsec, function(base64Image) {
                        eachQues.latexQues = base64Image
                    })
                    _.each(eachQues.choice, function(eachQnchice, index) {
                        let latexValue = encodeURIComponent(eachQues.choice[index].desc)
                        let urlsec = $scope.chartUrl + latexValue
                        getDataUri(urlsec, function(base64Image) {
                            eachQues.choice[index].latexDesc = base64Image
                        })
                    });
                }
            }
        }

        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "activityList"
        })
        $scope.activityUserPrivilege = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.activityUserPrivilege[tpObj.feature_id] = user_access;
            })
        }
        if (qpId) {
            authService.callAPI(activityCons.API_ACTIVITY_PREVIEW + qpId, "POST", {}, (response) => {
                if (response.result && response.result.status && response.result.data.details && response.result.data.details.length > 0) {
                    let result = response.result.data.details[0]
                    console.log(result)
                    $scope.allQuestions = result
                    $scope.qpDetails = result.qp_details[0]
                    $scope.activityId = result.qp_details[0].activity_id
                    if ($scope.qpDetails.status === 'conducted' || $scope.qpDetails.status === 'published')
                        $scope.isConducted = true
                    if ($scope.qpDetails.teacher_id === userId)
                        $scope.isCreator = true
                    _.each($scope.allQuestions.sections, function(eachSection) {
                        _.each(eachSection.questions, function(eachQues) {

                            if (eachQues.type == 'passage') {
                                _.each(eachQues.questions, function(ibtQues) {
                                    fieldAlignment(ibtQues)
                                })
                            } else {
                                fieldAlignment(eachQues)
                            }


                            if (eachQues.passage_image) {
                                convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQues.passage_image, function(base64Image) {
                                    $scope.imgurl3 = base64Image;
                                    eachQues.passage_image_url = $scope.imgurl3
                                    _.defer(function() {
                                        $scope.$apply();
                                    });
                                })
                            }
                            if (eachQues.image) {
                                eachQues.passage_image_arrayUrl = []
                                _.each(eachQues.image, function(eachQnImage) {
                                    convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachQnImage, function(base64Image) {
                                        eachQues.passage_image_arrayUrl.push(base64Image)
                                        _.defer(function() {
                                            $scope.$apply();
                                        });
                                    })
                                });
                            }
                            if (eachQues.optionAnswer && eachQues.optionAnswer.length > 0) {
                                _.each(eachQues.optionAnswer, function(eachChoice, index) {
                                    if (eachChoice.optImage) {
                                        convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachChoice.optImage, function(base64Image) {
                                            eachQues.optionAnswer[index].answerimage = base64Image
                                            _.defer(function() {
                                                $scope.$apply();
                                            });
                                        })
                                    }
                                })
                            }
                            if (eachQues.optionQuestion && eachQues.optionQuestion.length > 0) {
                                _.each(eachQues.optionQuestion, function(eachChoice, index) {
                                    if (eachChoice.questionImg) {
                                        convertFileToDataURLviaFileReader(CONSTANTS.FILE_UPLOAD_URL + eachChoice.questionImg, function(base64Image) {
                                            eachQues.optionQuestion[index].questionimage = base64Image
                                            _.defer(function() {
                                                $scope.$apply();
                                            });
                                        })
                                    }
                                })
                            }
                        })
                    })
                    $timeout(function() {
                        $scope.loadLatex()
                    });
                    $scope.isLoading = false
                    $scope.$apply()

                }
            })
        }

        $scope.gotoQpPreview = function() {
            if ($scope.isViewMode) {
                $state.go('activityFormPreview', {
                    resourceId: $scope.activityId
                })
            } else {
                $state.go('formatQp', {
                    resourceId: $scope.activityId
                })
            }
        }

        authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {}, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                $scope.qpHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': SchoolLogo.checkLogo(CONSTANTS.FILE_UPLOAD_URL + result.logo),
                    'subject': academics.subject,
                    'class': academics.class
                }
                convertFileToDataURLviaFileReader($scope.qpHeader.schoolLogo, function(base64Image) {
                    $scope.imgurl1 = base64Image;
                })
            } else {
                //error
            }
        })



        let MQ = MathQuill.getInterface(2);
        $scope.loadLatex = function() {
            let questionElements = document.getElementsByClassName('question_desc')
            _.each(questionElements, function(spanElement) {
                MQ.StaticMath(spanElement);
            })
        }

        $scope.convertURLTotrustUrl = function(url, index, type) {
            if (type == "question") {
                $scope.convertedURLQuestion[index] = $sce.trustAsResourceUrl($scope.file_server_url + url);
            } else if (type == 'answer') {
                $scope.convertedURLAnswer[index] = $sce.trustAsResourceUrl($scope.file_server_url + url);
            }
        }

        $scope.gotoSectionPage = function() {
            $state.go('formatQp', {
                resourceId: $scope.activityId
            })
        }
        $scope.teachingPlan = localStorageService.get("currentPlan")

        $scope.saveQuestionPaper = function() {
                $scope.resource = _.find($scope.teachingPlan.resources, function(res) {
                    return res._id === $scope.activityId
                })
                let academicDetails = {
                    session_id: academics.session_id,
                    curriculum_id: academics.curriculum_id,
                    batch_id: academics.batch_id,
                    class_id: academics.class_id,
                    subject_id: academics.subject_id,
                    school_id: academics.school_id,
                    class: academics.class,
                    batch: academics.batch,
                    curriculum: academics.curriculum,
                    subject: academics.subject,
                    class: academics.class,
                    session: academics.session,
                    user_id: userId,
                    qp_id: qpId,
                    plan_id: $scope.teachingPlan._id,
                    activity_id: $scope.activityId,
                    practice_qn: $scope.resource.isPractice
                }
                authService.callAPI(activityCons.API_SAVE_QP, "POST", academicDetails, (response) => {
                    if (response.result && response.result.status) {
                        toastr.success("Question Paper Saved Successfully")
                        $rootScope.setStatus($scope.activityId, "created")
                    }
                })
            }
            /*
             * Function To suffle match
             * @eachQues - MTF
             * @developer - Arul Mozhi J
             */
        $scope.suffleOptions = function(eachQues) {
            eachQues.choiceData = eachQues.option
            let optionQuestion = []
            let optionAnswer = []
            _.each(eachQues.option, function(eachOption) {
                optionQuestion.push(eachOption.question)
                optionAnswer.push(eachOption.answer)
            })

            //To shuffle match the following answers
            optionAnswer = _.shuffle(optionAnswer)
            eachQues.optionQuestion = optionQuestion
            eachQues.optionAnswer = optionAnswer
        }
        $scope.addPassword = function() {
            $scope.isPassword = true;
        }

        $scope.beautifyFIB = function(question) {
            return question.replace(/_/g, " _______ ")
        }

        $scope.closePasswordDiv = function() {
            $scope.isPassword = false;
        }

        /*
         * To set password to an activity
         * 
         *  @data : String - activity password
         * 
         * @return : null
         */
        $scope.saveActivityPassword = function(activityPassword) {
            if (activityPassword === "" || activityPassword === null || activityPassword === undefined)
                toastr.error("Please enter password")
            else {
                authService.callAPI(activityCons.API_SAVE_PASSWORD + qpId + '/' + userId + '/' + activityPassword, "POST", {}, (response) => {
                    if (response.result && response.result.status) {
                        toastr.success("Activity password saved successfully")
                    }
                })
                $scope.isPassword = false;
            }
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        function getDataUri(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        }

        $scope.generatePdf = () => {
                let content = [];
                content.push({
                    table: {
                        widths: [70, '*', 70],
                        body: [
                            [{
                                width: 70,
                                height: 70,
                                image: $scope.imgurl1,
                                rowSpan: '3'
                            }, {
                                text: $scope.qpHeader.schoolName,
                                style: 'title'
                            }, {}],
                            [{}, {
                                alignment: 'center',
                                text: $scope.qpDetails.question_paper_title
                            }, {}],
                            [{}, {
                                alignment: 'center',
                                text: $scope.qpHeader.subject
                            }, {}]
                        ]
                    },
                    layout: 'noBorders'
                })
                content.push({
                    canvas: [{
                        type: 'line',
                        x1: 0,
                        y1: 10,
                        x2: 520,
                        y2: 10,
                        lineWidth: 0.5
                    }]
                })
                content.push("\n")
                let hour = 0
                let min = 0
                if ($scope.qpDetails.time.hour)
                    hour = $scope.qpDetails.time.hour
                if ($scope.qpDetails.time.min)
                    min = $scope.qpDetails.time.min
                content.push({
                    columns: [{
                        text: "Time : " + "  " + hour + " hour  " + min + " min"
                    }, {
                        text: "Curriculum/Class : " + "  " + $scope.curriculum + "/" + $scope.class
                    }, {
                        text: "Maximum Marks : " + "  " + $scope.qpDetails.total_mark
                    }]
                })
                content.push({
                    canvas: [{
                        type: 'line',
                        x1: 0,
                        y1: 10,
                        x2: 520,
                        y2: 10,
                        lineWidth: 0.5
                    }]
                })
                let sections = angular.copy($scope.allQuestions.sections);
                _.each(sections, function(eachSection) {
                    let quesNo = 1
                    content.push("\n")
                    let policy;
                    if (eachSection.qn_no === eachSection.mandatory_no)
                        policy = "(Attend All)"
                    else
                        policy = "(Any " + eachSection.mandatory_no + ")"
                    let ob = {
                        columns: [{
                            text: eachSection.name + " " + policy,
                            alignment: 'center',
                            style: 'sectionTitle'
                        }]
                    }
                    content.push(ob)
                    let sectionInsPolicy = {
                        columns: [{
                            text: eachSection.instruction + ":",
                            style: 'sectionTitle'
                        }]
                    }
                    content.push(sectionInsPolicy)
                    _.each(eachSection.questions, function(eachQues) {
                        content.push("\n")
                        let obj;
                        let para;
                        if (eachQues.type === "passage") {
                            let paragraphTitle;
                            if (!eachQues.isLatex) {
                                paragraphTitle = [{
                                    width: 'auto',
                                    alignment: "left",
                                    text: quesNo + "."
                                }, {
                                    width: 500,
                                    text: eachQues.title ? eachQues.title : " ",
                                    style: 'boldStyle'
                                }]
                            } else {
                                paragraphTitle = [{
                                    width: 'auto',
                                    alignment: "left",
                                    text: quesNo + "."
                                }, {
                                    width: 500,
                                    text: eachQues.title ? eachQues.title : " ",
                                    style: 'boldStyle'
                                }]
                            }
                            content.push({
                                columns: paragraphTitle
                            })
                            content.push("\n")

                            let paragraph = pdfForElement("<p>" + eachQues.desc + "</p>")
                            para = paragraph
                            content.push(para);
                            content.push("\n")
                            if (eachQues.passage_image_arrayUrl) {
                                _.each(eachQues.passage_image_arrayUrl, function(eachQnImage) {
                                    let imgObj = {
                                        columns: [{
                                            alignment: 'left',
                                            width: 300,
                                            image: eachQnImage
                                        }]

                                    }
                                    content.push(imgObj)
                                    content.push("\n")
                                });
                            }
                            if (eachQues.passage_image_url) {
                                let imgObj = {
                                    columns: [{
                                        alignment: 'left',
                                        width: 300,
                                        image: eachQues.passage_image_url
                                    }]
                                }

                                content.push(imgObj)
                            }
                            content.push("\n")
                            let ibtQuesNo = 1;
                            _.each(eachQues.questions, function(ibtQues) {
                                if (!ibtQues.isLatex) {
                                    if (ibtQues.type === "FIB") {
                                        ibtQues.qn_desc = $scope.beautifyFIB(ibtQues.qn_desc)
                                    }

                                    obj = [{
                                        width: '*',
                                        alignment: "left",
                                        text: quesNo + "." + ibtQuesNo + ". " + ibtQues.qn_desc
                                    }, {
                                        width: 'auto',
                                        alignment: "right",
                                        text: "(" + ibtQues.mark + ")"
                                    }]
                                } else {
                                    obj = [{
                                        width: '*',
                                        alignment: "left",
                                        text: quesNo + "." + ibtQuesNo + ". " + ibtQues.latexQues
                                    }, {
                                        width: 'auto',
                                        alignment: "right",
                                        text: "(" + ibtQues.mark + ")"
                                    }]
                                }
                                content.push(obj)
                                if (ibtQues.qn_img_url) {
                                    let imgObj = {
                                        columns: [{
                                            alignment: 'left',
                                            width: 300,
                                            image: ibtQues.qn_img_url
                                        }]
                                    }
                                    content.push(imgObj)
                                    content.push("\n")
                                }
                                if (ibtQues.qn_img_urlarray) {
                                    _.each(ibtQues.qn_img_urlarray, function(eachQnImage) {
                                        let imgObj = {
                                            columns: [{
                                                alignment: 'left',
                                                width: 300,
                                                image: eachQnImage
                                            }]
                                        }
                                        content.push(imgObj)
                                        content.push("\n")
                                    });
                                }
                                if (ibtQues.type === "MCQ") {
                                    let ch = []
                                    _.each(ibtQues.choice, function(eachChoice) {
                                        if (!ibtQues.isLatex) {
                                            let choice = "(" + eachChoice.tag + ")  " + eachChoice.desc
                                            content.push({
                                                text: choice
                                            })
                                            content.push("\n")
                                            if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                                _.each(eachChoice.opt_image_url, function(eachImage) {
                                                    let imgObj = {
                                                        columns: [{
                                                            alignment: 'left',
                                                            width: 300,
                                                            image: eachImage
                                                        }]

                                                    }
                                                    content.push(imgObj)
                                                    content.push("\n")
                                                })
                                            }
                                        } else {
                                            let choice = "(" + eachChoice.tag + ")  "
                                            let choiceLatex = [{
                                                text: choice
                                            }, {
                                                image: eachChoice.latexDesc
                                            }]
                                            content.push(choiceLatex)
                                            content.push("\n")
                                            if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                                _.each(eachChoice.opt_image_url, function(eachImage) {
                                                    let imgObj = {
                                                        columns: [{
                                                            alignment: 'left',
                                                            width: 300,
                                                            image: eachImage
                                                        }]

                                                    }
                                                    content.push(imgObj)
                                                    content.push("\n")
                                                })
                                            }
                                        }

                                    })

                                }

                                /************** LINK QUESTION TO PASSAGE : START - Added by Arul Mozhi J  ****************/
                                if (ibtQues.type === "MTF") {
                                    let ch1 = []
                                    _.each(ibtQues.optionQuestion, function(optionQues) {
                                        if (!ibtQues.isLatex) {
                                            let choice = "(" + optionQues.tag + ")  " + optionQues.desc
                                            let chContent = []
                                            chContent.push([{
                                                text: choice,
                                                border: [false, false, false, false]
                                            }])
                                            if (optionQues.questionimage && optionQues.questionimage != "") {
                                                chContent.push([{
                                                    border: [false, false, false, false],
                                                    alignment: 'left',
                                                    width: 100,
                                                    height: 100,
                                                    image: optionQues.questionimage
                                                }])
                                            }
                                            ch1.push(chContent)
                                        } else {
                                            let choice = "(" + optionQues.tag + ")  "
                                            let chContent = []
                                            chContent.push([{
                                                text: choice,
                                                border: [false, false, false, false]
                                            }])
                                            if (optionQues.latexDesc) {
                                                chContent.push([{
                                                    /*text: choice,*/
                                                    image: optionQues.latexDesc,
                                                    border: [false, false, false, false],
                                                }])
                                            }
                                            if (optionQues.questionimage && optionQues.questionimage != "") {
                                                chContent.push([{
                                                    border: [false, false, false, false],
                                                    alignment: 'left',
                                                    width: 100,
                                                    height: 100,
                                                    image: optionQues.questionimage
                                                }])
                                            }
                                            ch1.push(chContent)

                                        }

                                    })
                                    let ch2 = [] // answerimage   questionimage
                                    _.each(ibtQues.optionAnswer, function(optionAns, ansIndex) {
                                        let choicesl = ansIndex + 1;
                                        if (!ibtQues.isLatex) {
                                            let choice = "(" + choicesl + ")  " + optionAns.desc
                                            let chContent = []
                                            chContent.push([{
                                                text: choice,
                                                border: [false, false, false, false]
                                            }])
                                            if (optionAns.answerimage && optionAns.answerimage != "") {
                                                chContent.push([{
                                                    border: [false, false, false, false],
                                                    alignment: 'left',
                                                    width: 100,
                                                    height: 100,
                                                    image: optionAns.answerimage
                                                }])
                                            }
                                            ch2.push(chContent)
                                        } else {
                                            let choice = "(" + choicesl + ")  "
                                            let chContent = []
                                            chContent.push([{
                                                text: choice,
                                                border: [false, false, false, false]
                                            }])
                                            if (optionAns.latexDesc) {
                                                chContent.push([{
                                                    image: optionAns.latexDesc,
                                                    border: [false, false, false, false],
                                                }])
                                            }
                                            if (optionAns.answerimage && optionAns.answerimage != "") {
                                                chContent.push([{
                                                    border: [false, false, false, false],
                                                    alignment: 'left',
                                                    width: 100,
                                                    height: 100,
                                                    image: optionAns.answerimage
                                                }])
                                            }
                                            ch2.push(chContent)
                                        }

                                    })
                                    content.push({
                                        table: {
                                            widths: ['*', '*', 90],
                                            body: [
                                                [{
                                                    text: "Question"
                                                }, {
                                                    text: "Option"
                                                }, {
                                                    text: "Answer"
                                                }]
                                            ]

                                        }
                                    })

                                    for (i = 0; i < ch1.length; i++) {
                                        let tableContent = [];
                                        tableContent.push({
                                            table: {
                                                body: ch1[i],
                                                layout: 'noBorders'
                                            }
                                        });
                                        tableContent.push({
                                            table: {
                                                body: ch2[i],
                                                layout: 'noBorders'
                                            }
                                        });
                                        tableContent.push({});
                                        content.push({
                                            table: {
                                                widths: ['*', '*', 90],
                                                body: [tableContent]
                                            }
                                        })
                                    }

                                }
                                if (ibtQues.type === "TF") {
                                    let ch = [];
                                    ch.push({
                                        text: "(A) True"
                                    })
                                    ch.push({
                                        text: "(B) False"
                                    })

                                    content.push({
                                        columns: ch
                                    })
                                }
                                /************** LINK QUESTION TO PASSAGE : END - Added by Arul Mozhi J  ****************/
                                ibtQuesNo = ibtQuesNo + 1
                            })
                        } else if (eachQues.type === "ASLLISTEN") {
                            obj = [{
                                width: 'auto',
                                alignment: "left",
                                text: quesNo + "."
                            }, {
                                width: 500,
                                text: eachQues.qn_desc + "(ASL)"
                            }, {
                                width: 'auto',
                                alignment: "right",
                                text: "(" + eachQues.mark + ")"
                            }]
                        } else if (eachQues.type === "ASLSPEAK") {
                            obj = [{
                                width: 'auto',
                                alignment: "left",
                                text: quesNo + "."
                            }, {
                                width: 500,
                                text: eachQues.qn_desc + "(ASL)"
                            }, {
                                width: 'auto',
                                alignment: "right",
                                text: "(" + eachQues.mark + ")"
                            }]
                        } else {
                            if (eachQues.type === "FIB") {
                                eachQues.qn_desc = $scope.beautifyFIB(eachQues.qn_desc)
                            }
                            if (!eachQues.isLatex) {
                                obj = [{
                                    width: 'auto',
                                    alignment: "left",
                                    text: quesNo + "."
                                }, {
                                    width: 500,
                                    text: eachQues.qn_desc ? eachQues.qn_desc : " "
                                }, {
                                    width: 'auto',
                                    alignment: "right",
                                    text: "(" + eachQues.mark + ")"
                                }]
                            } else {
                                let headObj = eachQues.latexQues ? {
                                    alignment: 'left',
                                    image: eachQues.latexQues
                                } : {
                                    width: 500,
                                    text: eachQues.qn_desc ? eachQues.qn_desc : " "
                                }
                                obj = [{
                                    width: 'auto',
                                    alignment: "left",
                                    text: quesNo + "."
                                }, headObj, {
                                    width: 'auto',
                                    alignment: "right",
                                    text: "(" + eachQues.mark + ")"
                                }]
                            }
                        }
                        content.push({
                            columns: obj
                        })
                        if (eachQues.qn_img_url) {
                            let imgObj = {
                                columns: [{
                                    alignment: 'left',
                                    width: 300,
                                    image: eachQues.qn_img_url
                                }]
                            }
                            content.push(imgObj)
                            content.push("\n")
                        }
                        if (eachQues.qn_img_urlarray) {
                            _.each(eachQues.qn_img_urlarray, function(eachQnImage) {
                                let imgObj = {
                                    columns: [{
                                        alignment: 'left',
                                        width: 300,
                                        image: eachQnImage
                                    }]

                                }
                                content.push(imgObj)
                                content.push("\n")
                            });
                        }

                        if (eachQues.type === "MCQ" || eachQues.type === "IBT_MCQ") {

                            let ch = []
                            _.each(eachQues.choice, function(eachChoice) {
                                if (!eachQues.isLatex) {
                                    let choice = "(" + eachChoice.tag + ")  " + eachChoice.desc
                                    content.push({
                                        text: choice
                                    })
                                    content.push("\n")
                                    if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                        _.each(eachChoice.opt_image_url, function(eachImage) {
                                            let imgObj = {
                                                columns: [{
                                                    alignment: 'left',
                                                    width: 300,
                                                    image: eachImage
                                                }]

                                            }
                                            content.push(imgObj)
                                            content.push("\n")
                                        })
                                    }
                                } else {
                                    let choice = "(" + eachChoice.tag + ")  "
                                    let choiceLatex = [{
                                        text: choice
                                    }, {
                                        image: eachChoice.latexDesc
                                    }]
                                    content.push(choiceLatex)
                                    content.push("\n")
                                    if (eachChoice.opt_image_url && eachChoice.opt_image_url.length > 0) {
                                        _.each(eachChoice.opt_image_url, function(eachImage) {
                                            let imgObj = {
                                                columns: [{
                                                    alignment: 'left',
                                                    width: 300,
                                                    image: eachImage
                                                }]

                                            }
                                            content.push(imgObj)
                                            content.push("\n")
                                        })
                                    }
                                }

                            })

                        }
                        if (eachQues.type === "MTF") {
                            let ch1 = []
                            _.each(eachQues.optionQuestion, function(optionQues) {
                                if (!eachQues.isLatex) {
                                    let choice = "(" + optionQues.tag + ")  " + optionQues.desc
                                        // ch1.push([{ text: choice,border: [false, false, false, false] }])
                                        // let imgObj = {
                                        //     border: [false, false, false, false],
                                        //     alignment: 'left',
                                        //     width: 100,
                                        //     image: optionQues.questionimage
                                        // }
                                    let chContent = []
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }])
                                    if (optionQues.questionimage && optionQues.questionimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionQues.questionimage
                                        }])
                                    }
                                    ch1.push(chContent)
                                } else {
                                    let choice = "(" + optionQues.tag + ")  "
                                    let chContent = []
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }])
                                    if (optionQues.latexDesc) {
                                        chContent.push([{
                                            /*text: choice,*/
                                            image: optionQues.latexDesc,
                                            border: [false, false, false, false],
                                        }])
                                    }
                                    if (optionQues.questionimage && optionQues.questionimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionQues.questionimage
                                        }])
                                    }
                                    ch1.push(chContent)

                                }

                            })
                            let ch2 = [] // answerimage   questionimage
                            _.each(eachQues.optionAnswer, function(optionAns, ansIndex) {
                                let choicesl = ansIndex + 1;
                                if (!eachQues.isLatex) {
                                    let choice = "(" + choicesl + ")  " + optionAns.desc
                                    let chContent = []
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }])
                                    if (optionAns.answerimage && optionAns.answerimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionAns.answerimage
                                        }])
                                    }
                                    ch2.push(chContent)
                                } else {
                                    let choice = "(" + choicesl + ")  "
                                    let chContent = []
                                    chContent.push([{
                                        text: choice,
                                        border: [false, false, false, false]
                                    }])
                                    if (optionAns.latexDesc) {
                                        chContent.push([{
                                            image: optionAns.latexDesc,
                                            border: [false, false, false, false],
                                        }])
                                    }
                                    if (optionAns.answerimage && optionAns.answerimage != "") {
                                        chContent.push([{
                                            border: [false, false, false, false],
                                            alignment: 'left',
                                            width: 100,
                                            height: 100,
                                            image: optionAns.answerimage
                                        }])
                                    }
                                    ch2.push(chContent)
                                }

                            })
                            content.push({
                                table: {
                                    widths: ['*', '*', 90],
                                    body: [
                                        [{
                                            text: "Question"
                                        }, {
                                            text: "Option"
                                        }, {
                                            text: "Answer"
                                        }]
                                    ]

                                }
                            })

                            for (var i = 0; i < ch1.length; i++) {
                                let tableContent = [];
                                tableContent.push({
                                    table: {
                                        body: ch1[i],
                                        layout: 'noBorders'
                                    }
                                });
                                tableContent.push({
                                    table: {
                                        body: ch2[i],
                                        layout: 'noBorders'
                                    }
                                });
                                tableContent.push({});
                                content.push({
                                    table: {
                                        widths: ['*', '*', 90],
                                        body: [tableContent]
                                    }
                                })
                            }

                        }
                        if (eachQues.type === "TF") {
                            let ch = [];
                            ch.push({
                                text: "(A) True"
                            })
                            ch.push({
                                text: "(B) False"
                            })

                            content.push({
                                columns: ch
                            })
                        }
                        if (eachQues.type === "ASLLISTEN") {
                            _.each(eachQues.questions, function(ques, index) {
                                let quesData = [{
                                    width: 10,
                                    text: ""
                                }, {
                                    width: "auto",
                                    alignment: "left",
                                    text: index + 1
                                }, {
                                    width: 500,
                                    text: ques.qn_desc,
                                }]
                                content.push({
                                    columns: quesData
                                })
                                if (ques.type === "mcq") {
                                    let ch = []
                                    _.each(ques.choice, function(eachChoice) {
                                        if (ques.isLatex) {
                                            let choice = "(" + eachChoice.tag + ")" + eachChoice.desc
                                            ch.push({
                                                text: choice
                                            })
                                        } else {
                                            let choice = "(" + eachChoice.tag + ")  "
                                            ch.push({
                                                text: choice
                                            })
                                            ch.push({
                                                image: eachChoice.latexDesc
                                            })

                                        }
                                    })
                                    content.push({
                                        columns: ch
                                    })
                                } else if (ques.type === "tf") {
                                    let ch = [];
                                    ch.push({
                                        text: "(A) True"
                                    })
                                    ch.push({
                                        text: "(B) False"
                                    })

                                    content.push({
                                        columns: ch
                                    })
                                }
                            })
                        }
                        quesNo++;
                    })
                    content.push({
                        canvas: [{
                            type: 'line',
                            x1: 0,
                            y1: 10,
                            x2: 520,
                            y2: 10,
                            lineWidth: 0.5
                        }]
                    })
                })

                let font = $scope.qpHeader.subject == 'Malayalam' ? 'Rachana' : $scope.qpHeader.subject == 'Hindi' ? 'Kruti' : 'Roboto'

                var docDefinition = {
                    info: {
                        title: $scope.allQuestions.title
                    },
                    content: content,
                    styles: {
                        title: {
                            fontSize: 18,
                            bold: true,
                            alignment: 'center'
                        },
                        sectionTitle: {
                            bold: true,
                            italics: true
                        },
                        boldStyle: {
                            bold: true
                        }
                    },
                    defaultStyle: {
                        font: font
                    }
                }
                pdfMake.createPdf(docDefinition).open();
            }
            /*
             * Function check whether it is array or not
             * @obj - Object/Array to check
             */
        $scope.isArray = function(obj) {
            return Array.isArray(obj);
        }
        function showMetadataPopUp (metadata, question) {
            $mdDialog.show({
                controller: ['$scope', '$mdDialog', 'metadata', 'question', questionMetadataTpCtrl],
                locals: {
                    "metadata": metadata,
                    question : question

                },
                template: metadataPopUpTemplate,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                // fullscreen: useFullScreen
            })
        }
        $scope.getmetadata = (oneQuestion) => {
            console.log(oneQuestion)
            let obj = {
                "args":
                {
                    "qpId":qpId,
                    "question_id" : oneQuestion._id,
                    "school_id": localStorageService.get('school_id'),
                    "user_id":userId,
                    "teacher_id":userId
                }
            }

            authService.callAPI("/v0/get-question/metadata", "POST", obj, (response) => {
                if (response.result && response.result.status) {
                    try{
                        showMetadataPopUp(response.result.data, oneQuestion)
                    }catch(e){
                        console.log(e)
                    }
                }
            })
        }
    }
}
export default QpPreviewController
var pdfForElement = function(htmlTextInput) {

    //Parse inner elements
    function ParseContainer(cnt, e, p, styles) {
        var elements = [];
        var children = e.childNodes;
        if (children.length != 0) {
            for (var i = 0; i < children.length; i++) {
                p = ParseElement(elements, children[i], p, styles);
            }
        }
        if (elements.length != 0) {
            for (var i = 0; i < elements.length; i++) {
                cnt.push(elements[i]);
            }
        }
        return p;
    }

    //Convert styles to pdfmake JSON
    function ComputeStyle(o, styles) {
        for (var i = 0; i < styles.length; i++) {
            styles[i] = styles[i].replace()
            var st = styles[i].trim().toLowerCase().split(":");
            if (st.length == 2) {
                st[0] = st[0].trim()
                st[1] = st[1].trim()
                switch (st[0]) {
                    case "font-size":
                        {
                            o.fontSize = parseInt(st[1]);
                            break;
                        }
                    case "text-align":
                        {
                            switch (st[1]) {
                                case "right":
                                    o.alignment = 'right';
                                    break;
                                case "center":
                                    o.alignment = 'center';
                                    break;
                            }
                            break;
                        }
                    case "font-weight":
                        {
                            switch (st[1]) {
                                case "bold":
                                    o.bold = true;
                                    break;
                            }
                            break;
                        }
                    case "text-decoration":
                        {
                            switch (st[1]) {
                                case "line-through":
                                    o.decoration = "lineThrough";
                                    break;
                                case "underline":
                                    o.decoration = "underline";
                                    break;
                            }
                            break;
                        }
                    case "font-style":
                        {
                            switch (st[1]) {
                                case "italic":
                                    o.italics = true;
                                    break;
                            }
                            break;
                        }
                }
            }
        }
    }

    //Parse each element
    function ParseElement(cnt, e, p, styles) {
        if (!styles) {
            styles = [];
        }
        //If styles in the element
        if (e.getAttribute) {
            var nodeStyle = e.getAttribute("style");
            if (nodeStyle) {
                var ns = nodeStyle.split(";");
                for (var k = 0; k < ns.length; k++) {
                    if (ns[k]) {
                        styles.push(ns[k]);
                    }
                }
            }
        }
        switch (e.nodeName.toLowerCase()) {
            case "#text":
                {
                    var t = {
                        text: e.textContent.replace(/\n/g, "")
                    };
                    if (styles) {
                        ComputeStyle(t, styles);
                    }
                    if (p.text) {
                        p.text.push(t)
                    } else if (p.ul) {
                        p.ul.push(t)
                    } else if (p.ol) {
                        p.ol.push(t)
                    }
                    break;
                }
            case "b":
            case "strong":
                {
                    ParseContainer(cnt, e, p, styles.concat(["font-weight:bold"]));
                    break;
                }
            case "strike":
                {
                    ParseContainer(cnt, e, p, styles.concat(["text-decoration:line-through"]));
                    break;
                }
            case "u":
                {
                    ParseContainer(cnt, e, p, styles.concat(["text-decoration:underline"]));
                    break;
                }
            case "i":
                {
                    ParseContainer(cnt, e, p, styles.concat(["font-style:italic"]));
                    break;
                }
            case "span":
                {
                    ParseContainer(cnt, e, p, styles);
                    break;
                }
            case "br":
                {
                    p = CreateParagraph();
                    var t = {
                        text: "\n"
                    };
                    p.text.push(t)
                    cnt.push(p);
                    break;
                }
            case "blackquote":
            case "div":
            case "p":
                {
                    p = CreateParagraph();
                    ParseContainer(cnt, e, p, styles);
                    cnt.push(p);
                    break;
                }
            case "ul":
                {
                    ul = createList("ul");
                    ParseContainer(cnt, e, ul, styles);
                    cnt.push(ul);
                    break;
                }
            case "ol":
                {
                    ol = createList("ol");
                    ParseContainer(cnt, e, ol, styles);
                    cnt.push(ol);
                    break;
                }
            case "li":
                {
                    ParseContainer(cnt, e, p, styles);
                    break;
                }
            default:
                {
                    p = CreateParagraph();
                    ParseContainer(cnt, e, p);
                    cnt.push(p);
                    break;
                }
        }
        return p;
    }


    //Create pragragh content in pdfmake
    function CreateParagraph() {
        var p = {
            text: []
        };
        return p;
    }

    //Create pragragh content in pdfmake
    function createList(type) {
        if (type === "ol") {
            var list = {
                ol: []
            };
            return list;
        }
        if (type === "ul") {
            var list = {
                ul: []
            };
            return list
        }
    }

    //Parse HTML input and convert to JSON
    function ParseHtml(cnt, htmlText) {
        var html = $(htmlText.replace(/\t/g, "").replace(/\n/g, ""));
        var p = CreateParagraph();
        for (var i = 0; i < html.length; i++) {
            ParseElement(cnt, html.get(i), p);
        }
    }
    let content = [];
    ParseHtml(content, htmlTextInput);
    return content
}
class questionMetadataTpCtrl {
    constructor($scope, $mdDialog, metadata, question) {
        metadata['qn_desc'] = question.qn_desc
        metadata['type'] = question.type
        
        $scope.metadata = metadata
        $scope.hide = function() {
          $mdDialog.hide();
        };

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

    }
}


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/activity/tpActivityPreview.js